class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.announcement-bar__slider');
    this.speed = Number(this.dataset.speed);

    this.initSlider();
  }

  initSlider() {
    const announcementSlider = new Swiper(this.slider, {
      slidesPerView: 1,
      loop: true,
      watchOverflow:  true,
      autoplay: {
        delay: this.speed || 4000,
      }
    });
  }
}

window.customElements.define('announcement-bar', AnnouncementBar);